import logo from '../assets/logo.svg';

export default async () =>
	new Promise(async (resolve) => {
		const config = {
			whiteLabel: 'Witty',
			defaultLang: 'nl_NL',
			files: [
				{
					id: 'testfile',
					file: logo,
				},
			],
			pages: {
				appBox: {
					showResultsPercentage: true,
				},
				appLogin: {
					showHeaderTitle: true,
					showLogo: false,
					headerTitleIsHtml: false,
					showFootNote: false,
					visualTitle: true,
					footerLogo: true,
				},
				appRegistration: {
					showBirthDate: true,
					showPhoneNumber: true,
					showRegisterType: false,
					showRegisterCode: false,
					registerCodeRequired: false,
					addMoreLicenses: true,
					webshop: true,
				},
				appNoLicense: {
					showFootNote: false,
				},
				appAccount: {
					showEducation: true,
					showAddProduct: true,
					hideDelete: true,
					hideSchoolClass: true,
					hideFunction: true,
				},
				box: {
					scrollTo: false,
				},
				boxCard: {
					showDescription: true,
				},
				dashboard: {
					scrollTo: false,
				},
				appDashboard: {
					alternativeContent: true,
				},
				appElementOverlay: {
					showHeaderTitle: true,
				},
				general: {
					showStudentRapports: true,
					rapportType: 'userprogress',
				},
				showDashboard: false,
			},
			elementCardConfig: {
				noPercentage: false
			},
			caseConfig: {
				redoButtons: true,
			},
			assignmentConfig: {
				redoButtons: true,
			},
			general: {
				showFilters: true,
				showMenuLabel: true,
				hideTimer: false,
				downloadRapportage: true,
				showTags: true,
				playButtonAsIcon: true,
				secondStatisticsBox: true,
				licenseUrl: 'https://www.visavi.nl/Leermiddelen/',
				showScenesButton: true,
				hideTeacherMessage: true,
				hideReadSpeaker: true,
				sso: true,
				disableLoginPage: false
			},
			elements: {
				exerciseCard: false,
			},
			getFile: (id) => config.files.find((file) => file.id === id),
			getPage: (key) => config[key],
		};

		resolve(config);
	});
